export const selectCoords=(state)=>[state.coordinates.lat, state.coordinates.lng]